export const NAVIGATE_TO = 'NAVIGATE_TO';

export const navigateTo = (path) => ({
  type: NAVIGATE_TO,
  payload: path,
});
